import React from 'react';
import {
  Divider,
  Typography,
  Container,
  Item,
  Card,
  CardContent,
  AuthButton,
} from 'components';
import { withStyles, createStyleSheet } from 'material-ui/styles';

const styleSheet = createStyleSheet('NotAuthenticated', () => ({
  button: {
    width: '100%',
  },
  divider: {
    margin: 16,
  },
}));

const NotAuthenticated = ({ classes }) => {
  return (
    <Container>
      <Item>
        <Card>
          <CardContent>
            <Typography type="display1" align="center">
              로그인이 필요 합니다.
            </Typography>
            <Divider className={classes.divider} />
            <AuthButton color="accent" raised className={classes.button}>
              로그인 하기
            </AuthButton>
          </CardContent>
        </Card>
      </Item>
    </Container>
  );
};
export default withStyles(styleSheet)(NotAuthenticated);



// WEBPACK FOOTER //
// ./src/common/components/NotAuthenticated.js